<template>
  <container>
    <checkout-progress reservation />

    <header
      v-if="loading"
      class="cart__header"
    >
      {{ $t('confirming') }} <strong>{{ reservation }}</strong> … {{ $t('pleaseWait') }} <br>
      <loader-spinner :size="1.5" />
    </header>

    <header
      v-if="!loading"
      class="cart__header"
    >
      <headline>{{ $t(result + '.title') }}</headline>
      <p v-html="$t(result + '.message')" />
    </header>

    <cart-reservation-download
      v-if="success"
      :barcode="barcode"
    />
  </container>
</template>

<script>
import cartReservationDownload from '../components/cartReservationDownload.vue'
import checkoutProgress from '../components/checkoutProgress.vue'
import container from '../components/container.vue'
import headline from '../components/headline.vue'
import loaderSpinner from '../components/loaderSpinner.vue'

import api from '../api.js'
import eventBus from '../eventBus.js'

export default {
  name: 'VReservationConfirmation',

  components: {
    cartReservationDownload,
    checkoutProgress,
    container,
    headline,
    loaderSpinner
  },

  data () {
    return {
      loading: true,
      success: false,
      showMessage: false,
      barcode: this.$route.params.barcode
    }
  },

  created () {
    this.canConfirm()
  },

  mounted () {
    this.$tracking.track(this.$route.path, 'r-con')
  },

  methods: {
    canConfirm () {
      api.post('reservations/' + this.barcode + '/is_confirmed/').then(response => {
        if (response.data === false) {
          this.confirm()
        } else {
          this.loading = false
          this.success = true
          this.result = 'alreadyConfirmed'
        }
      }, () => {
        eventBus.emit('handleError')
      })
    },

    confirm () {
      api.post('reservations/' + this.barcode + '/confirm/').then(response => {
        this.loading = false
        this.result = (response.status === 204) ? 'success' : 'error'
        this.showMessage = true
        this.success = (response.status === 204)
      }, () => {
        eventBus.emit('handleError')
      })
    }
  }
}
</script>

<i18n locale="en">
{
  "confirming": "Confirming reservation",
  "pleaseWait": "Please wait",
  "alreadyConfirmed": {
    "title": "Reservation",
    "message": "Your reservation has already been confirmed."
  },
  "success": {
    "title": "Reservation confirmed",
    "message": "Thank you for your reservation – we’re looking forward to your visit to Miniatur Wunderland!<br>We have sent you your tickets via email, however you can also download them here immediately if you like."
  },
  "error": {
    "title": "Confirmation failed",
    "message": "Your reservation could not be confirmed."
  }
}
</i18n>

<i18n locale="de">
{
  "confirming": "Bestätige Reservierung",
  "pleaseWait": "Bitte warten Sie",
  "alreadyConfirmed": {
    "title": "Reservierung",
    "message": "Ihre Reservierung ist bereits bestätigt."
  },
  "success": {
    "title": "Reservierung bestätigt",
    "message": "Vielen Dank für Ihre Reservierung – wir freuen uns auf Ihren Besuch im Miniatur Wunderland Hamburg!<br>Wir haben Ihnen Ihre Tickets per E-Mail zugesendet, aber Sie können sie sich auch hier bereits herunterladen."
  },
  "error": {
    "title": "Bestätigung fehlgeschlagen",
    "message": "Ihre Reservierung konnte nicht bestätigt werden."
  }
}
</i18n>
